// DEPRECATED NOW UTILS.MONITORING
import { getUUID } from './api';
import { sendJSError } from './js';

export const api = { getUUID };

export const js = { sendJSError };

export const monitoringUtils = {
  api,
  js,
};

export default monitoringUtils;
